// frontend/components/auth/index.ts

export { ProtectedRoute } from "./ProtectedRoute";
